import { admissionDatabaseApi } from "@/src/api/axiosInstance";
import { joinBaseUrlAndPath } from "@/src/utils/joinUrl";

export const resolveTaskAttachedFileUrl = (attachedFile?: string | null): string | null => {
  const trimmed = attachedFile?.trim();
  if (!trimmed) return null;
  return joinBaseUrlAndPath(admissionDatabaseApi.defaults.baseURL ?? "", trimmed);
};
